

import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
import Component, { mixins } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { VApp, VContent } from "vuetify/lib";
import appStorage from "@/lib/appStorage";
import config from "@/config";
import MainHeader from "@/components/main/MainHeader.vue";
import MainSideMenu from "@/components/main/MainSideMenu.vue";
import MainFooter from "@/components/main/MainFooter.vue";
import StatusBar from "@/components/StatusBar.vue";
import PageNotFound from "@/views/PageNotFound.vue";
import emitter from "@/lib/helpers/emitter";
import { EVENT_NAMES } from "@teacherskaya/api-provider/dist";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { EVENTS } from "@/lib/const";
import WithLoggedInUser from "@/mixins/WithLoggedInUser";

Vue.use(VueCompositionAPI);

document.title = config.siteName;

type TMixins = WithLoggedInUser;

@Component({
  components: {
    PageNotFound,
    StatusBar,
    MainFooter,
    MainSideMenu,
    MainHeader,
    VApp,
    VContent,
  },
})
export default class App extends mixins<TMixins>(WithLoggedInUser) {
  public hideMenu: boolean = false;

  public showSideMenu = appStorage.getBoolean("isSideMenuShown", false);

  public get pageNotFound() {
    return this.$store.state.pageNotFound;
  }

  @Watch("showSideMenu")
  public watchShowSideMenu(value: boolean) {
    appStorage.setBoolean("isSideMenuShown", value);
  }

  @Watch("$route", { immediate: true })
  public watchRoute(route: Route, prev: Route | undefined) {
    this.hideMenu =
      route.path === "/login" ||
      route.path === "/login/forgot" ||
      route.name === "loginForgotEmail" ||
      route.name === "loginForgotSet";
    if (this.pageNotFound && route.path !== prev?.path) {
      this.$store.commit("setPageNotFound", false);
    }
  }

  public setUserHandler(payload: { user: User | null } | null) {
    if (payload === null || payload.user === null) {
      if (this.$store.dispatch("logout")) {
        this.$router
          .push("/login")
          .then(() => emitter.emit<any>(EVENTS.STATUS_NOTIFICATIONS.HIDE_ALL))
          // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-empty-function
          .catch(() => {});
      }
    }
  }

  public async created() {
    emitter.on<any>(EVENT_NAMES.SET_USER, this.setUserHandler);
  }

  public destroyed() {
    emitter.off<any>(EVENT_NAMES.SET_USER, this.setUserHandler);
  }
}
